import { Box, IconButton, Tooltip } from "@mui/material";
import { AppIconsMessage } from "../../../AppIcons";

type TOfferOrderNoteIconComponent = {
    item: any;
};

const OfferOrderNoteIconComponent = (props: TOfferOrderNoteIconComponent) => {
    return (
        <Box>
            {props.item.note ? (
                <Tooltip
                    children={<AppIconsMessage />}
                    title={props.item.note}
                    placement="top"
                    disableInteractive
                />
            ) : (
                <></>
            )}
        </Box>
    );
};

export default OfferOrderNoteIconComponent;
